<template>
    <div>
      <h1>WebSocket Room Test</h1>
      <button @click="sendShowImage">Bild an Room senden</button>
      <div v-if="imageUrl">
        <h3>Empfangenes Bild:</h3>
        <img :src="imageUrl" alt="Empfangenes Bild" style="max-width: 300px; margin-top: 20px;">
      </div>
    </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';

export default {
  name: 'TestSocket',
  props: {
    sessionId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const socket = ref(null);
    const imageUrl = ref('');
    const sessionId = ref('');

    function getSessionIdFromUrl() {
      const parts = window.location.pathname.split('/');
      return parts.pop() || parts.pop();
    }

    function connectWebSocket() {
      sessionId.value = getSessionIdFromUrl();

      if (!sessionId.value) {
        console.error('Keine Session-ID im Pfad gefunden!');
        return;
      }
      // console.log(this.$router.currentRoute.params.id);
      socket.value = new WebSocket('ws://localhost:3000');

      socket.value.addEventListener('open', () => {
        console.log('WebSocket verbunden');
        socket.value.send(JSON.stringify({
          cmd: 'init',
          id: sessionId.value,
        }));
      });

      socket.value.addEventListener('message', (event) => {
        console.log('Nachricht vom Server:', event.data);
        const command = JSON.parse(event.data);

        if (command.cmd === 'init') {
          console.log('Init erhalten');
        }
        if (command.cmd === 'initdata') {
          console.log('Init-Daten:', command.data);
        }
        if (command.cmd === 'show-image') {
          imageUrl.value = command.imageUrl;
          console.log('Bild empfangen:', imageUrl.value);
        }
      });

      socket.value.addEventListener('close', () => {
        console.log('WebSocket geschlossen');
      });

      socket.value.addEventListener('error', (error) => {
        console.error('WebSocket Fehler:', error);
      });
    }

    function sendShowImage() {
      if (socket.value && socket.value.readyState === WebSocket.OPEN) {
        socket.value.send(JSON.stringify({
          cmd: 'show-image',
          userName: 'Max Mustermann',
          eventName: 'Test',
          imageUrl: 'http://localhost:3000/img/thofu_main/Soundalert_overlay_dark.png',
          audioUrl: 'http://localhost:3000/img/thofu_441039586/2-4SubAlert.mp3',
          duration: '12000',
        }));
      }
    }

    onMounted(() => {
      connectWebSocket();
    });

    onBeforeUnmount(() => {
      if (socket.value) {
        socket.value.close();
      }
    });

    return {
      imageUrl,
      sendShowImage,
    };
  },
};
</script>

<style scoped>
  button {
    padding: 10px 20px;
    background-color: #4caf50;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  button:hover {
    background-color: #45a049;
  }
</style>
